@if (isVisible) {
    <div class="fixed inset-0 w-screen h-screen overflow-y-auto bg-gray-500 text-slate-900 bg-opacity-70 p-2 z-[100]">
        <div class="flex items-center justify-center p-10 pt-20">
            <div #modalPanel class="flex flex-col w-[360px] sm:w-[40%] min-h-[75%] bg-slate-100 rounded card-shadow-light">
                <!-- Title -->
                <div class="flex flex-row bg-ponder-light text-white p-2 rounded-t shadow items-center gap-2">
                    <div class="w-2 h-2 shadow-sm rounded-sm" [style.background]="getStatusColor()"></div>
                    <div class="grow">View Task: {{ taskId }}</div>
                    <button (click)="onClose()" class="stroke-faded-50 hover:stroke-white hover:cursor-pointer">
                        <svg class="w-6 h-6 fill-none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" stroke-width="1">
                            <path stroke-linecap="round" stroke-linejoin="round" [attr.d]="closeSvgIcon" />
                        </svg>
                    </button>
                </div>
                <!-- Body -->
                <div class="flex flex-col pb-2 pl-4 pr-4 gap-2 text-sm">
                    <loading [isLoading]="isLoading" [success]="loadingSuccess"></loading>
                    @if (!isLoading) {
                        <div class="flex flex-row items-center gap-4 text-base">
                            <button (click)="onLogsClicked()" class="hover:cursor-default" [ngClass]="{ 'text-slate-400 hover:cursor-pointer' : !showLogs }">Logs</button>
                            <button (click)="onParametersClicked()" class="hover:cursor-default" [ngClass]="{ 'text-slate-400 hover:cursor-pointer' : showLogs }">Parameters</button>
                        </div>
                        <!-- Log Output -->
                        <div #logContainer class="p-2 bg-slate-50 rounded shadow-sm max-h-64 min-h-48 overflow-y-auto font-mono text-xs break-words" [ngClass]="{ 'hidden' : !showLogs}">
        
                        </div>
                        <!-- Task Parameters -->
                        <div #taskParameters class="p-2 bg-slate-50 rounded shadow-sm max-h-64 min-h-48 overflow-y-auto font-mono text-xs" [ngClass]="{ 'hidden' : showLogs}">
        
                        </div>
                        <!-- Task Info -->
                         @if (taskRun) {
                            <div class="flex flex-row gap-2 items-center">
                                <div class="p-2 text-white rounded shadow-sm text-center cursor-default" [style.background]="getStatusColor()">
                                    {{ taskStatus }}
                                </div>
                                <div class="flex flex-row p-2 bg-slate-50 items-center rounded shadow-sm cursor-default" [attr.title]="taskRun.startedAt">
                                    {{ taskRun.taskName }}
                                </div>
                                <div class="flex flex-row p-2 bg-slate-50 items-center rounded shadow-sm cursor-default" [attr.title]="taskRun.startedAt">
                                    Started at: {{ taskRun.startedAt | date }}
                                </div>
                                <div class="flex flex-row p-2 bg-slate-50 items-center rounded shadow-sm cursor-default">
                                    Started by: {{ taskRun.startedBy }}
                                </div>
                                <div class="grow border-r text-transparent">.</div>
                                <button class="flex flex-row p-2 bg-slate-50 items-center rounded shadow-sm cursor-pointer border border-opacity-0 hover:border-opacity-100 hover:border-ponder-link hover:text-ponder-link">
                                    Rerun Task
                                </button>
                            </div>
                         }
                    }
                </div>
            </div>
        </div>
    </div>
}